import { DialogController } from 'aurelia-dialog';
import type { ActivateLike, DialogCloser } from './DialogHandler';

abstract class MnDialog<TArg = unknown, TResult = unknown> implements ActivateLike<TArg>, DialogCloser<TResult> {
  constructor(private dc: DialogController) {}

  /**
   * Closes the dialog with the provided output and a success status.
   * This is typically used when the dialog operation completes successfully,
   * such as when the user submits a form or confirms an action.
   *
   * {wasCancelled: false, output?: TResult}
   *
   * @param output - The output to return when closing the dialog.
   * @param ok - Whether the dialog is closing successfully (default is true).
   * @returns The output provided.
   */
  closeWithResult(output?: TResult): TResult {
    void this.dc.close(true, output);
    return output;
  }

  /**
   * Cancels the dialog operation with a cancel result.
   * This is typically used when the user decides to cancel the dialog.
   *
   * {wasCancelled: true}
   */
  cancelDialog() {
    void this.dc.cancel();
  }

  abstract activate(_: TArg): void;
}

export { MnDialog };
